'use client';

import styled from 'styled-components';

import { colors } from '@/styles/theme';

// Per-variant gradient + icon color tokens, all using existing theme palette.
const variants = {
  lecturer: {
    background: `radial-gradient(circle at 30% 25%, ${colors.peach} 0%, ${colors.brown} 100%)`,
    iconColor: colors.lagoon,
  },
  education: {
    background: `radial-gradient(circle at 30% 25%, ${colors.peach} 0%, ${colors.simba} 100%)`,
    iconColor: colors.light,
  },
  post: {
    background: `radial-gradient(circle at 30% 25%, ${colors.gray1} 0%, ${colors.brown} 100%)`,
    iconColor: colors.lagoon,
  },
};

export const PlaceholderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background: ${({ $variant }) => variants[$variant]?.background || variants.post.background};
  color: ${({ $variant }) => variants[$variant]?.iconColor || variants.post.iconColor};

  /* Inherit any rounding from parent ImageWrap so it tucks in cleanly */
  border-radius: inherit;

  user-select: none;
  pointer-events: none;

  /* Subtle inner shading for depth */
  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.08);

  & > svg {
    opacity: 0.85;
    /* Soften the icon edges a touch */
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
  }
`;
